import { apiInstance } from "@/api/instance";

export default async function (params) {
  return apiInstance.get("/beauty", { params });
}
